import LPressable from "@components/LPressable";
import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import { LPressableProps } from "@components/LPressable";

export default function Close(props: LPressableProps) {
  return (
    <LPressable {...props}>
      <LBox
        padding="s2"
        backgroundColor="whiteTranslucent10"
        borderRadius="max"
        width={32}
        height={32}
        justifyContent="center"
        alignItems="center"
      >
        <LIcon name="cross" size={16} />
      </LBox>
    </LPressable>
  );
}
